import React from "react";
import ReactStars from "react-rating-stars-component";
import { useState } from "react";

export const Feedback = () => {

    const [FeedbackVal, setFeedbackVal] = useState(1);

    const ratingChanged = (newRating) => {
        setFeedbackVal(newRating);
    };

    // https://www.npmjs.com/package/react-rating-stars-component

    return (
        <>
            <div className="sb-feedback-sec">
                <ReactStars
                    count={5}
                    onChange={ratingChanged}
                    size={24}
                    activeColor="#F2E205"
                    color="#CFE3DA"
                />


                <p className="sb-feedback-sec__desc">Response: {FeedbackVal} out of 5 stars</p>
            </div>

        </>
    )
}
